"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
/* eslint-disable no-param-reassign */
var _require = require('bson'),
  ObjectId = _require.ObjectId;
var _ = require('lodash');
var moment = require('moment');
var FINDING_STATUSES = require('../../../common/constant/finding-status.constant');
var FINDING_VALUES = require('../../../common/constant/finding-value.constant');
var _require2 = require('../../../common/constant/report-status.constant'),
  DONE = _require2.DONE,
  DRAFT = _require2.DRAFT,
  PENDING_UPLOADS = _require2.PENDING_UPLOADS,
  READY_FOR_REVIEW = _require2.READY_FOR_REVIEW,
  SENT_TO_RP = _require2.SENT_TO_RP;
module.exports = /*@ngInject*/function ($anchorScroll, $filter, $http, $location, $q, $rootScope, $scope, $uibModal, $window, isPublicView, report, ConfigService, EmailService, ENV, PartyService, PreferenceService, ProfileService, ProgramService, ReportService, InvitationService, $routeParams, CONFIG, IDLE_TIMEOUT_WARNING, ConfirmModelService, IdleHelper) {
  var ctrl = this;
  var Amplify = $window.aws_amplify;
  var referenceRegex = new RegExp('^[\\w\\.-]{4,20}$');
  ctrl.findingValues = FINDING_VALUES;
  ctrl.findingStatuses = FINDING_STATUSES;
  ctrl.reportStatuses = {
    DONE: DONE,
    DRAFT: DRAFT,
    SENT_TO_RP: SENT_TO_RP
  };
  ctrl.findingValueOptions = ReportService.findingValueOptions;
  ctrl.env = ENV;
  ctrl.isPublicView = isPublicView;
  ctrl.report = report;
  ctrl.showWorkflow = false;
  ctrl.workflow = null;
  ctrl.lightbox = null;
  ctrl.editFinding = {
    id: null,
    action: null
  };
  ctrl.profile = ProfileService.getProfile();
  ctrl.managers = [];
  ctrl.errorFiles = [];
  ctrl.showDeleteConfirm = false;
  ctrl.isAdmin = ctrl.isPublicView ? false : ProfileService.isAdmin();
  ctrl.isManagerForParty = ctrl.isPublicView ? false : ProfileService.isManagerForParty(ctrl.report.party.id);
  ctrl.isRoutingGroupForConfig = ctrl.isPublicView ? false : ProfileService.isRoutingGroupForConfig(ctrl.report.configuration);
  ctrl.isSafetyCoordinatorForParty = ctrl.isPublicView ? false : ProfileService.isSafetyCoordinatorForParty(ctrl.report.party.id);
  ctrl.isAdminForProgram = ctrl.isPublicView || !ctrl.report._id ? false : ProfileService.isAdminForProgram(ctrl.report.configuration.program);
  ctrl.isInspectorForProgram = ctrl.isPublicView || !ctrl.report._id ? false : ProfileService.isInspector(ctrl.report.configuration);
  ctrl.isSuperUser = ctrl.isPublicView ? false : ProfileService.isSuperUser();
  ctrl.selectedNote = undefined;
  ctrl.noteAction = undefined;
  ctrl.today = new Date();
  ctrl.showResendConfirm = false;
  ctrl.showRollbackConfirm = false;
  ctrl.showActionConfirmation = {
    value: false,
    message: ''
  };
  // eslint-disable-next-line no-undef
  ctrl.isDownloadSupported = function () {
    return !!new Blob();
  };
  ctrl.files = [];
  ctrl.isEditableStatus = ctrl.report.status !== SENT_TO_RP && ctrl.report.status !== DONE;
  ctrl.getAcceptedAttachmentFormats = ReportService.ACCEPTED_ATTACHMENT_FORMATS;
  ctrl.recentAttachments = [];
  ctrl.showReferencePencilIcon = true;
  ctrl.referenceIdError = '';
  ctrl.hideInfoOnPrint = ProfileService.redactInspectorsOnPrint();
  ctrl.showEditRp = false;
  ctrl.defaultIdleTimeout = null;
  ctrl.defaultIdleWarn = null;
  ctrl.defaultIdleStart = null;
  ctrl.uploadProgress = false;
  ctrl.setEditRP = function () {
    var config = {};
    ProgramService.get({
      id: ctrl.report.configuration.program
    }, function (result) {
      config = result.configurations.find(function (c) {
        return c._id === ctrl.report.configuration._id;
      });
      ctrl.showEditRp = config.updatePartyPeople && ![SENT_TO_RP, DONE].includes(ctrl.report.status) && (ctrl.isAdminForProgram || ctrl.isInspectorForProgram);
    });
  };
  ctrl.formatDate = function () {
    ctrl.report.createdDate = new Date(ctrl.report.createdDate).getTime();
  };
  ctrl.init = function (r) {
    if (r) {
      ctrl.report = r;
    }
    if (ctrl.report._id) {
      ctrl.activeFindingId = $routeParams.activeFindingId;
      ctrl.activeIncidentId = $routeParams.activeIncidentId;
      ctrl.catName = $routeParams.catName;
      ctrl.showCompliantFindings = ctrl.isPublicView ? true : !!PreferenceService.get().showCompliantFindings;
      ctrl.isInspectorAndAdminView = true;
      ctrl.showWarning = ctrl.report.status !== SENT_TO_RP && ReportService.hasIncompleteCategories(ctrl.report);
      ctrl.noteAction = ctrl.report.status !== DRAFT && (ctrl.isManagerForParty || ctrl.isSafetyCoordinatorForParty) ? 'READ_ONLY' : undefined;
      if (!ctrl.isPublicView) {
        ctrl.setEditRP();
      }
      var savedCategories = PreferenceService.get()["".concat(ctrl.report._id, "_categories")];
      if (savedCategories) {
        ctrl.report.categories = _.cloneDeep(savedCategories);
        PreferenceService.clear("".concat(ctrl.report._id, "_categories"));
      } else {
        ctrl.report.categories.forEach(function (category) {
          category.$$hasSubmittedAndNoIssues = ctrl.hasSubmittedAndNoIssues(ctrl.report, category);
          category.$$hasNotSubmitted = ctrl.hasNotSubmitted(ctrl.report, category);
          category.$$collapse = ctrl.report.configuration.categoriesCollapsed;
        });
      }
      if (ctrl.catName && ctrl.activeIncidentId && ctrl.report.configuration.categoriesCollapsed) {
        ctrl.report.categories.forEach(function (category) {
          if (decodeURIComponent(ctrl.catName) === category.name) {
            category.$$collapse = false;
            $location.search('catName', null);
          }
        });
      }
      ctrl.calculateManagers(ctrl.report);
      ctrl.calculateUnresolvedIncidentsOnCategory(ctrl.report);
      ctrl.referenceId = ctrl.report.referenceId;
      ctrl.formatDate();
      ctrl.cancelEdit();
      ctrl.opened = {};
      ctrl.dateFormats = ['yyyy-MM-dd', 'MM/dd/yyyy', 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
      ctrl.scrollTo();
    }
  };
  ctrl.getFindingValueOptions = function (findingType) {
    return ReportService.getFindingValueOptions(ctrl.findingValueOptions, findingType);
  };
  ctrl.scrollTo = function () {
    if (ctrl.activeFindingId) {
      $location.search('activeFindingId', null);
      $location.hash(ctrl.activeFindingId);
      $anchorScroll.yOffset = 300;
      $anchorScroll();
    }
  };
  ctrl.calculateUnresolvedIncidentsOnCategory = function (rep) {
    ctrl.incidentCountMap = new Map();
    rep.categories.forEach(function (category) {
      ctrl.incidentCountMap.set(category.name, {
        nonCompliantCount: 0,
        unResolvedCount: 0
      });
    });
    rep.findings.forEach(function (finding) {
      finding.incidents.forEach(function (incident) {
        if (incident.value === ctrl.findingValues.NOT_COMPLIANT) {
          if (ctrl.incidentCountMap.get(incident.category)) {
            // eslint-disable-next-line no-plusplus
            ctrl.incidentCountMap.get(incident.category).nonCompliantCount++;
          }
        }
        if ([ctrl.findingStatuses.NOT_RESOLVED, ctrl.findingStatuses.IN_PROGRESS, ctrl.findingStatuses.READY_FOR_VERIFICATION].includes(incident.status)) {
          if (ctrl.incidentCountMap.get(incident.category)) {
            // eslint-disable-next-line no-plusplus
            ctrl.incidentCountMap.get(incident.category).unResolvedCount++;
          }
        }
      });
    });
  };
  function conflictReportModal() {
    ConfirmModelService.confirm(ConfirmModelService.ConfirmType.CONFIRM, {
      message: 'This report was edited by another user since your last save, and cannot capture your changes. Please refresh the report before making changes.',
      header: 'Conflict Detected',
      buttons: {
        cancel: {
          label: 'Cancel'
        },
        ok: {
          label: 'Refresh'
        }
      }
    }, function () {
      $window.location.reload();
    });
  }
  ctrl.open = function (item) {
    ctrl.opened[item] = true;
  };
  ctrl.editInspectionDate = function () {
    ctrl.showPencilIcon = false;
    ctrl.showDatepicker = true;
  };
  ctrl.cancelEdit = function () {
    ctrl.showPencilIcon = true;
    ctrl.showDatepicker = false;
  };
  ctrl.editReferenceId = function () {
    ctrl.referenceId = ctrl.report.referenceId;
    ctrl.showReferencePencilIcon = false;
    ctrl.showReferenceId = true;
    ctrl.referenceIdError = '';
  };
  ctrl.cancelEditReferenceId = function () {
    ctrl.showReferencePencilIcon = true;
    ctrl.showReferenceId = false;
    ctrl.referenceIdError = '';
  };
  ctrl.updateInspectionDate = function () {
    ctrl.inspectionDateProgress = true;
    ctrl.cancelEdit();
    ReportService.update(ctrl.report).$promise.then(function (rep) {
      Object.assign(ctrl.report, _.omit(rep, 'categories'));
      ctrl.formatDate();
      ctrl.inspectionDateProgress = false;
    })["catch"](conflictReportModal);
  };
  ctrl.saveReferenceId = function (referenceId) {
    var signout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!referenceRegex.test(referenceId) && referenceId !== '') {
      ctrl.referenceIdError = 'Please enter a valid reference id.';
    } else {
      ctrl.referenceIdProgress = true;
      ctrl.report.referenceId = referenceId;
      ctrl.cancelEditReferenceId();
      ReportService.update(ctrl.report).$promise.then(function (re) {
        if (signout) {
          Amplify.Auth.signOut();
        } else {
          Object.assign(ctrl.report, _.omit(re, 'categories'));
        }
        ctrl.referenceIdProgress = false;
      })["catch"](conflictReportModal);
    }
  };
  ctrl.findThumbnail = function (thumbnails, attachmentId) {
    var match = thumbnails.find(function (thumbnail) {
      return thumbnail._id === attachmentId;
    });
    return match.thumbnail || null;
  };
  ctrl.encodeURIComponent = function (value) {
    return encodeURIComponent(value);
  };
  ctrl.isCategoryStarted = function (selectedCategory) {
    return ReportService.isCategoryStarted(ctrl.report.findings, selectedCategory.name);
  };
  ctrl.isCategoryComplete = function (selectedCategory) {
    return ReportService.isCategoryComplete(ctrl.report.findings, selectedCategory.name, selectedCategory.multipleSeries);
  };
  ctrl.hasUntouchedIncidents = function (selectedCategory) {
    return ctrl.report.findings.filter(function (finding) {
      return !selectedCategory || finding.categories.some(function (category) {
        return category.name === selectedCategory.name;
      });
    }).some(function (finding) {
      return finding.incidents.length === 0 || finding.incidents.some(function (incident) {
        return !incident.meta.touched;
      });
    });
  };
  ctrl.hasNotObservedFinding = function (selectedCategory) {
    return ctrl.report.findings.filter(function (finding) {
      return !selectedCategory || finding.categories.some(function (category) {
        return category.name === selectedCategory.name;
      });
    }).some(function (finding) {
      return finding.type === 'NOT_OBSERVED';
    });
  };
  ctrl.stopPropagation = function (event) {
    event.stopPropagation();
  };
  ctrl.addDefaultAnswerToIncidents = function (answer, selectedCategory, index, categoryIndex) {
    ctrl.progressCategory = true;
    ctrl.selectedCategoryName = selectedCategory && selectedCategory.name;
    ctrl.report.categories.filter(function (category) {
      return !selectedCategory || selectedCategory.name === category.name;
    }).forEach(function (category) {
      var filteredFindings = ReportService.filterFindingsAndIncidentsByCategory(ctrl.report.findings, category.name);
      var seriesIndex = category.multipleSeries && index ? index : 0;
      ReportService.addDefaultAnswerToIncidents(filteredFindings, category, answer, seriesIndex, ctrl.report, ctrl.profile, !!selectedCategory);
    });
    var clonedCategories = _.cloneDeep(ctrl.report.categories);
    ReportService.update(ctrl.report).$promise.then(function (repo) {
      ctrl.report = repo;
      ctrl.report.categories.forEach(function (category) {
        category.$$collapse = clonedCategories.find(function (clonedCategory) {
          return clonedCategory.name === category.name;
        }).$$collapse;
      });
      ctrl.formatDate();
      ctrl.getInspectors(ctrl.report);
      ctrl.showWarning = ctrl.report.status !== SENT_TO_RP && ReportService.hasIncompleteCategories(ctrl.report);
      ctrl.progressCategory = false;
      $location.hash(categoryIndex);
      $anchorScroll.yOffset = 300;
      $anchorScroll();
    })["catch"](conflictReportModal);
  };
  ctrl.addIncident = function (finding, categoryName, status) {
    var incident = ReportService.initializeIncident(finding, categoryName, status, ctrl.profile, new ObjectId().toString(), ctrl.report.configuration.verificationDefaultValue);
    incident.meta.touched = true;
    ReportService.updateIncident({
      id: ctrl.report._id,
      findingId: finding.id,
      incidentId: incident.id
    }, incident).$promise.then(function (response) {
      response.categories.forEach(function (category, index) {
        category.$$collapse = ctrl.report.categories[index].$$collapse;
      });
      ctrl.report = response;
    });
  };
  ctrl.redirectToIncidentDetail = function (finding, categoryName, status) {
    $location.path("/report/".concat(ctrl.report._id, "/finding/").concat(finding.id, "/incident/new")).search({
      category: categoryName,
      status: status
    });
  };
  ctrl.calculateManagers = function (rep) {
    ctrl.managers = [];
    var getPeopleCallback = function getPeopleCallback(partyToPeople) {
      ctrl.managers = partyToPeople.people;
    };
    if (ctrl.isPublicView) {
      PartyService.getPeoplePublic({
        partyId: rep.configuration.party,
        partyMemberId: rep.party.id,
        shareableToken: rep.shareableToken
      }, getPeopleCallback);
    } else {
      PartyService.getPeople({
        partyId: rep.configuration.party,
        partyMemberId: rep.party.id
      }, getPeopleCallback);
    }
  };
  ctrl.getInspectionResolvers = function (rep) {
    var resolvers = [];
    rep.findings.forEach(function (finding) {
      finding.incidents.forEach(function (incident) {
        incident.resolutions.forEach(function (resolution) {
          if (resolution.action === 'RESOLVED') {
            resolvers.push(resolution.createdBy);
          }
        });
      });
    });
    return _.uniqBy(resolvers, 'userId');
  };
  ctrl.toggleWorkflow = function (id, incidentId) {
    var workflowHistory = incidentId ? ReportService.getIncidentHistory({
      id: id,
      incidentId: incidentId
    }) : ReportService.getReportHistory({
      id: id
    });
    workflowHistory.$promise.then(function (wf) {
      ctrl.workflow = wf;
    });
  };
  ctrl.toggleEdit = function (finding, action) {
    ctrl.editFinding = {
      id: finding ? finding.id : null,
      action: action,
      comments: null,
      tracking: null
    };
  };
  ctrl.hasSubmittedAndNoIssues = function (rep, category) {
    var findings = rep.findings.filter(function (finding) {
      return finding.categories.some(function (c) {
        return c.name === category.name;
      });
    });
    return !findings.every(function (finding) {
      return finding.incidents.length === 0;
    }) && !findings.some(function (finding) {
      return finding.incidents.length > 0 && finding.incidents.some(function (incident) {
        return incident.value === FINDING_VALUES.NOT_COMPLIANT || incident.value !== FINDING_VALUES.NOT_COMPLIANT && (incident.comments || incident.attachments.length > 0);
      });
    });
  };
  ctrl.hasNotSubmitted = function (rep, category) {
    var findings = rep.findings.filter(function (finding) {
      return finding.categories.some(function (c) {
        return c.name === category.name;
      });
    });
    return findings.every(function (finding) {
      return finding.incidents.length === 0;
    });
  };
  ctrl.hasIncidents = function (finding) {
    return finding.incidents.some(function (incident) {
      return ctrl.showIncident(incident);
    });
  };
  ctrl.showIncident = function (incident) {
    var isNotCompliant = incident.value === FINDING_VALUES.NOT_COMPLIANT;
    return isNotCompliant || !isNotCompliant && (incident.comments || incident.attachments.length > 0) || ctrl.showCompliantFindings;
  };
  ctrl.toggleShowCompliantFindings = function () {
    ctrl.showCompliantFindings = !ctrl.showCompliantFindings;
    PreferenceService.save('showCompliantFindings', ctrl.showCompliantFindings);
  };
  ctrl.toggleView = function () {
    ctrl.isInspectorAndAdminView = !ctrl.isInspectorAndAdminView;
  };
  ctrl.getInspectors = function (rep) {
    var inspectors = [];
    _.each(rep.findings, function (finding) {
      _.each(finding.incidents, function (incident) {
        inspectors.push(incident.createdBy);
      });
    });
    return _.uniqBy(inspectors, 'userId');
  };
  ctrl.friendlyValue = function (value) {
    if (value === null) {
      return 'Not Identified';
    }
    if (value === FINDING_VALUES.NA) {
      return 'Not Applicable';
    }
    return value;
  };
  ctrl.sortFinding = function (finding) {
    switch (finding.value) {
      case FINDING_VALUES.NOT_COMPLIANT:
        return 0;
      case FINDING_VALUES.COMPLIANT:
        return 1;
      case FINDING_VALUES.NA:
        return 2;
      default:
        return 3;
    }
  };
  ctrl.hasPermission = function (obj, permission) {
    return obj.permissions.indexOf(permission) >= 0;
  };
  ctrl.printReport = function () {
    return $window.print();
  };
  ctrl.deleteReport = function (r3, del) {
    if (del && ctrl.hasPermission(r3, 'DELETE')) {
      ctrl.progress = true;
      ReportService["delete"]({
        id: r3._id
      }).$promise.then(function () {
        ctrl.progress = false;
        ctrl.backToReportList();
      });
    } else {
      ctrl.showDeleteConfirm = false;
    }
  };
  ctrl.backToReportList = function () {
    $location.path('/report');
  };
  ctrl.citeFinding = function (findingId) {
    var editFinding = _.find(report.findings, {
      id: findingId
    });
    editFinding.value = FINDING_VALUES.NOT_COMPLIANT;
    ReportService.updateFinding({
      id: report._id
    }, editFinding, function (result) {
      if (result) {
        $location.path("/report/".concat(report._id, "/finding/").concat(findingId));
      }
    });
  };
  ctrl.removeFinding = function (findingId) {
    var removeFinding = _.find(report.findings, {
      id: findingId
    });
    removeFinding.correctedOnSite = false;
    removeFinding.comments = null;
    removeFinding.locatoin = null;
    removeFinding.actionPlan = null;
    removeFinding.value = null;
    removeFinding.status = null;
    removeFinding.attachments = [];
    removeFinding.responsibleParty = [];
    removeFinding.resolutions = [];
    removeFinding.resolutions = null;
    removeFinding.createdBy = null;
    ctrl.findingDeleteProgress = true;
    ReportService.updateFinding({
      id: report._id
    }, removeFinding, function () {
      ctrl.findingDeleteProgress = false;
    });
  };
  ctrl.resendReport = function (shouldResend) {
    if (shouldResend) {
      ctrl.progress = true;
      ReportService.resendToRP({
        id: report._id
      }, {}).$promise.then(function () {
        ctrl.progress = false;
        ctrl.showResendConfirm = false;
        ctrl.showActionConfirmation.value = true;
        ctrl.showActionConfirmation.message = 'The report has been sent again successfully.';
      });
    } else {
      ctrl.showResendConfirm = false;
    }
  };
  ctrl.rollbackReport = function (shouldRollback) {
    if (shouldRollback) {
      ctrl.progress = true;
      ReportService.rollback({
        id: report._id
      }, {}).$promise.then(function () {
        ctrl.progress = false;
        ctrl.showRollbackConfirm = false;
        ctrl.showActionConfirmation.value = true;
        ctrl.showActionConfirmation.message = 'The report has been rolled back successfully.';
        $window.location.reload();
      });
    } else {
      ctrl.showRollbackConfirm = false;
    }
  };
  ctrl.actionConfirmationClose = function () {
    ctrl.showActionConfirmation = {};
  };
  ctrl.showWarningSection = function () {
    return ctrl.report.status === DRAFT && !ctrl.showDeleteConfirm && ctrl.getInspectors(ctrl.report).length > 0 || ctrl.hasPermission(ctrl.report, 'SEND') && !ctrl.showDeleteConfirm || ctrl.showDeleteConfirm || ctrl.showResendConfirm || ctrl.showActionConfirmation.value || ctrl.showRollbackConfirm;
  };
  ctrl.setLightbox = function (attachment) {
    ctrl.lightbox = attachment;
  };
  ctrl.addNoteAttachments = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2() {
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          if (!(ctrl.files && ctrl.files.length)) {
            _context2.next = 4;
            break;
          }
          ctrl.uploadProgress = true;
          _context2.next = 4;
          return Promise.allSettled(ctrl.files.map(/*#__PURE__*/function () {
            var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(file) {
              var fileType, _yield$ReportService$, uploadedFile, error, _yield$ReportService$2, signedUrl, attachment;
              return _regenerator["default"].wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    fileType = file.type && file.type.indexOf('image') > -1 ? 'IMAGE' : 'DOCUMENT';
                    _context.next = 3;
                    return ReportService.uploadFile(file);
                  case 3:
                    _yield$ReportService$ = _context.sent;
                    uploadedFile = _yield$ReportService$.uploadedFile;
                    error = _yield$ReportService$.error;
                    if (!error) {
                      _context.next = 11;
                      break;
                    }
                    ctrl.errorFiles.push({
                      fileName: file.name,
                      error: error
                    });
                    _.remove(ctrl.files, _.find(ctrl.files, file));
                    _context.next = 20;
                    break;
                  case 11:
                    _context.next = 13;
                    return ReportService.downloadFile(uploadedFile.name);
                  case 13:
                    _yield$ReportService$2 = _context.sent;
                    signedUrl = _yield$ReportService$2.signedUrl;
                    _context.next = 17;
                    return ReportService.createAttachmentData(uploadedFile, signedUrl, fileType);
                  case 17:
                    attachment = _context.sent;
                    ctrl.selectedNote.attachments.push(attachment);
                    ctrl.recentAttachments.push(attachment);
                  case 20:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }()));
        case 4:
          ctrl.uploadProgress = false;
          ctrl.files = [];
          ctrl.errorFiles = [];
          if (!$scope.$$phase) $scope.$apply();
        case 8:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  ctrl.removeNoteAttachment = function (attachment) {
    var index = ctrl.selectedNote.attachments.findIndex(function (noteAttachment) {
      if (attachment.id) {
        // attachment hasn't been submitted to server yet
        return attachment.id === noteAttachment.id;
      }
      if (attachment.attachmentId) {
        // attachment is either thumbnail or a document, not retrieved from server
        return attachment.attachmentId === noteAttachment.attachmentId;
      }
      // attachment is retrieved from server
      return attachment._id === noteAttachment.attachmentId;
    });
    ctrl.selectedNote.attachments.splice(index, 1);
  };
  ctrl.downloadImage = function (lightbox) {
    ReportService.downloadFile(lightbox.s3Name).then(function (res) {
      lightbox.$$signedUrl = res.data.signedUrl;
    });
  };
  ctrl.submitAsComplete = function (completedReport) {
    ctrl.progress = true;
    ReportService.mergeDraft({}, completedReport).$promise.then(function () {
      ctrl.progress = false;
      $location.path("/report");
    });
  };
  ctrl.getMessage = function (type, re, callback) {
    ctrl.progress = true;
    if (!re.configuration.sendEmail) {
      return callback(re);
    }
    ReportService.getReportNotification({
      id: re._id,
      type: type
    }).$promise.then(function (notification) {
      ctrl.progress = false;
      if (re.configuration.hasReview) {
        var partyDescription = re.party.description ? "<small>".concat(re.party.description, "</small>") : '';
        var options = {
          addRecipients: false,
          addRecipientMessage: "<br>Please use Management > Location/People (tab) to add manager(s) for <strong class=\"text-group\">".concat(re.party.name, " ").concat(partyDescription, "</strong>")
        };
        EmailService.getMessage(re, notification, ctrl.profile.campusCode, options, callback);
      } else {
        callback(re, notification);
      }
    });
  };
  ctrl.sendToRp = function (rep, notification) {
    ctrl.progress = true;
    ReportService.sendToRP({
      id: rep._id
    }, notification).$promise.then(function () {
      ctrl.progress = false;
      $location.path('/report');
    });
  };
  ctrl.submitForReview = function (rep) {
    ctrl.progress = true;
    ReportService.submitForReview({}, rep).$promise.then(function () {
      ctrl.progress = false;
      $location.path('/report');
    });
  };
  ctrl.addNoteAction = function () {
    ctrl.selectedNote = {
      attachments: [],
      visibility: CONFIG.NODE_ENV === 'hc' ? 'PRIVATE' : 'PUBLIC'
    };
    ctrl.noteAction = 'ADD_NOTE';
  };
  ctrl.editNoteAction = function (note) {
    ctrl.noteAction = 'EDIT_NOTE';
    ctrl.selectedNote = _.cloneDeep(note);
  };
  ctrl.deleteNoteAction = function (note) {
    ctrl.noteAction = 'DELETE_NOTE';
    ctrl.selectedNote = _.cloneDeep(note);
  };
  ctrl.cancelNote = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return Promise.all(ctrl.recentAttachments.map(function (attachment) {
            return ReportService.deleteAttachment({
              name: attachment.s3Name
            });
          }));
        case 2:
          ctrl.recentAttachments = [];
          ctrl.notesProgress = false;
          ctrl.selectedNote = undefined;
          ctrl.noteAction = undefined;
        case 6:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  function notesCallback(response) {
    ctrl.report.notes = response.notes || [];
    ctrl.report.lastModified = response.lastModified;
    ctrl.cancelNote();
  }
  function buildShareableLink(shareableToken) {
    if (!shareableToken) {
      return null;
    }
    return "".concat($location.absUrl().substr(0, $location.absUrl().lastIndexOf('#')), "#!/public/report/").concat(shareableToken);
  }
  ctrl.saveNote = function (rep, note) {
    var signout = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    ReportService.removeUnsavedAttachments(ctrl.recentAttachments, note.attachments);
    ctrl.recentAttachments = [];
    ctrl.notesProgress = true;
    ReportService.upsertNote({
      id: rep._id
    }, note).$promise.then(function (response) {
      notesCallback(response);
      if (signout) {
        Amplify.Auth.signOut();
      }
    });
  };
  ctrl.deleteNote = function (rep, note) {
    ctrl.notesProgress = true;
    ReportService.deleteNote({
      id: rep._id,
      noteId: note.id
    }).$promise.then(notesCallback);
  };
  ctrl.addNewSeries = function (category) {
    ReportService.addSeries({
      id: ctrl.report._id.toString(),
      categoryName: category.name
    }, {}).$promise.then(function (rep) {
      return Object.assign(ctrl.report, _.omit(rep, 'categories'));
    });
  };
  ctrl.updateSeries = function (category, index, type) {
    ReportService.updateSeries({
      id: ctrl.report._id.toString(),
      categoryName: category.name,
      index: index
    }, {
      type: type
    }).$promise.then(function (rep) {
      return Object.assign(ctrl.report, _.omit(rep, 'categories'));
    });
  };
  ctrl.deleteSeries = function (category, index) {
    $uibModal.open({
      templateUrl: 'report/detail/_series.delete.confirm.html',
      controllerAs: '$ctrl',
      backdrop: 'static',
      // eslint-disable-next-line object-shorthand
      controller: function controller($uibModalInstance) {
        var $ctrl = this;
        $ctrl.ok = function () {
          ReportService.deleteSeries({
            id: ctrl.report._id.toString(),
            categoryName: category.name,
            index: index
          }).$promise.then(function (rep) {
            Object.assign(ctrl.report, _.omit(rep, 'categories'));
            $uibModalInstance.dismiss('cancel');
          });
        };
        $ctrl.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
      }
    });
  };
  ctrl.emailShareableLink = function (shareableLink, newLink) {
    var notification = {
      bodyHtml: "\n        Hello,<br><br>Select the link below to view the public report for ".concat(ctrl.report.party.name, " that was performed on\n        ").concat(moment(ctrl.report.createdDate).calendar(), ".<br><br><a href=").concat(shareableLink, ">").concat(shareableLink, "</a><br>\n      "),
      subject: "".concat(ctrl.profile.firstName, " ").concat(ctrl.profile.lastName, " is sharing ").concat(ctrl.report.party.name, " Inspection Report")
    };
    var options = {
      disableRecipients: false,
      addRecipients: true,
      addRecipientMessage: null
    };
    EmailService.getMessage(report, notification, ctrl.profile.campusCode, options, function (rep, notifi) {
      ReportService.sendPublicReport({
        id: rep._id
      }, notifi);
    }, function () {
      if (newLink) {
        ReportService.deactivateShareableLink({
          id: ctrl.report._id
        }, {}).$promise.then(function (rep) {
          Object.assign(ctrl.report, _.omit(rep, 'categories'));
        });
      }
    });
  };
  ctrl.shareReport = function () {
    if (ctrl.isAdmin) {
      if (!ctrl.report.shareableToken) {
        ReportService.generateShareableLink({
          id: ctrl.report._id
        }, {}).$promise.then(function (rep) {
          Object.assign(ctrl.report, _.omit(rep, 'categories'));
          ctrl.emailShareableLink(buildShareableLink(rep.shareableToken), true);
        });
      } else {
        ctrl.emailShareableLink(buildShareableLink(ctrl.report.shareableToken), false);
      }
    } else {
      $uibModal.open({
        templateUrl: 'report/detail/_report.share.html',
        controllerAs: '$ctrl',
        backdrop: 'static',
        // eslint-disable-next-line object-shorthand
        controller: function controller($uibModalInstance) {
          var $ctrl = this;
          ctrl.shareableLinkModalInstance = $uibModalInstance;
          $ctrl.shareableLink = buildShareableLink(ctrl.report.shareableToken);
          $ctrl.progress = false;
          $ctrl.cancel = function () {
            $uibModalInstance.dismiss('cancel');
          };
          $ctrl.copy = function () {
            // eslint-disable-next-line no-undef
            var copyText = document.getElementById('shareableLink');
            copyText.select();
            // eslint-disable-next-line no-undef
            document.execCommand('copy');
          };
          $ctrl.generateLink = function () {
            ReportService.generateShareableLink({
              id: report._id
            }, {}).$promise.then(function (rep) {
              Object.assign(ctrl.report, _.omit(rep, 'categories'));
              $ctrl.shareableLink = buildShareableLink(ctrl.report.shareableToken);
            });
          };
        }
      });
    }
  };
  ctrl.deactivateShareableLinkConfirm = function () {
    $uibModal.open({
      templateUrl: 'report/detail/_report.share.deactivate.confirm.html',
      controllerAs: '$ctrl',
      backdrop: 'static',
      // eslint-disable-next-line object-shorthand
      controller: function controller($uibModalInstance) {
        var $ctrl = this;
        $ctrl.cancel = function () {
          $uibModalInstance.dismiss('cancel');
        };
        $ctrl.deactivateLink = function () {
          ReportService.deactivateShareableLink({
            id: ctrl.report._id
          }, {}).$promise.then(function (rep) {
            Object.assign(ctrl.report, _.omit(rep, 'categories'));
            $uibModalInstance.dismiss('cancel');
            ctrl.shareableLinkModalInstance.dismiss('cancel');
          });
        };
      }
    });
  };
  ctrl.openContactManageModal = function () {
    $uibModal.open({
      templateUrl: 'report/detail/_report.invite.contacts.html',
      controllerAs: '$ctrl',
      backdrop: 'static',
      // eslint-disable-next-line object-shorthand
      controller: function controller($uibModalInstance) {
        var $ctrl = this;
        $ctrl.contactToRemove = null;
        $ctrl.contacts = ctrl.managers;
        $ctrl.dislayRemoveError = false;
        $ctrl.contact = null;
        $ctrl.selectedContact = null;
        $ctrl.contactAlreadyExists = false;
        $ctrl.profileCampusCode = ctrl.profile.campusCode;
        $ctrl.contactToAdd = null;
        $ctrl.displayAddError = false;
        $ctrl.inviteForm = null;
        $ctrl.inviteActive = false;
        $ctrl.searchActive = true;
        $ctrl.showRPInvite = CONFIG.NODE_ENV !== 'prod';
        $ctrl.displayRemoveError = false;
        $ctrl.close = function () {
          $uibModalInstance.dismiss('cancel');
        };
        $ctrl.showRemoveConfirm = function (selected) {
          $ctrl.contactToRemove = selected;
        };
        $ctrl.hideRemoveConfirm = function () {
          $ctrl.contactToRemove = null;
        };
        $ctrl.showInvite = function () {
          $ctrl.inviteActive = true;
          $ctrl.searchActive = false;
        };
        $ctrl.cancelInvite = function () {
          $ctrl.inviteForm = null;
          $ctrl.inviteActive = false;
          $ctrl.searchActive = true;
          $ctrl.contact = null;
          $ctrl.noResults = false;
        };
        $ctrl.removeContact = function () {
          var responsiblePerson = _.cloneDeep($ctrl.contactToRemove);
          _.remove(responsiblePerson.parties, {
            id: ctrl.report.party.id
          });
          responsiblePerson.partyToRemoveId = ctrl.report.party.id;
          PartyService.updatePartyPeople({
            partyPeopleId: ctrl.report.configuration.partyToPeople,
            action: 'DELETE'
          }, responsiblePerson, function (result) {
            if (result.ok) {
              _.remove(ctrl.managers, {
                userId: responsiblePerson.userId
              });
              $ctrl.contacts = ctrl.managers;
              $ctrl.hideRemoveConfirm();
            } else {
              $ctrl.displayRemoveError = true;
            }
          });
        };
        $ctrl.selectedContact = function (person) {
          if (!_.some($ctrl.contacts, function (contact) {
            return contact.userId === person.userId;
          })) {
            $ctrl.contactAlreadyExists = false;
            $ctrl.contactToAdd = person;
          } else {
            $ctrl.contactAlreadyExists = true;
          }
        };
        $ctrl.addContact = function (isValid, contact) {
          if (isValid) {
            $ctrl.addPartyPeople(contact);
            $ctrl.contact = null;
            $ctrl.contactToAdd = null;
          }
        };
        $ctrl.resetError = function () {
          $ctrl.inviteError = '';
        };
        $ctrl.resetInvite = function () {
          $ctrl.inviteForm = null;
        };
        $ctrl.inviteContact = function (inviteForm, personToInvite) {
          if (inviteForm) {
            InvitationService.invite(personToInvite).$promise.then(function (result) {
              if (result.error) {
                $ctrl.inviteError = result.error;
              } else {
                personToInvite.userId = result.id;
                $ctrl.addPartyPeople(personToInvite);
                $ctrl.resetInvite();
              }
            });
          } else {
            $ctrl.inviteError = 'The form is incomplete, please fill out the missing field(s)';
          }
        };
        $ctrl.addPartyPeople = function (contact) {
          contact.parties = [{
            id: ctrl.report.party.id,
            name: ctrl.report.party.name,
            type: 'MANAGER'
          }];
          PartyService.updatePartyPeople({
            partyPeopleId: ctrl.report.configuration.partyToPeople,
            action: 'CREATE'
          }, contact, function (result) {
            if (result.ok) {
              ctrl.managers.push(contact);
              $ctrl.contacts = ctrl.managers;
            } else {
              $ctrl.displayAddError = true;
            }
          });
        };
      }
    });
  };
  ctrl.canEditHeader = function () {
    return [DRAFT, PENDING_UPLOADS, READY_FOR_REVIEW].includes(ctrl.report.status) && ctrl.isAdminForProgram;
  };
  ctrl.readOnlyHeader = function () {
    return !ctrl.isAdminForProgram || [DONE, SENT_TO_RP].includes(ctrl.report.status) && ctrl.isAdminForProgram;
  };
  ctrl.setUpTimeout = function () {
    ctrl.defaultIdleTimeout = $rootScope.$$listeners.IdleTimeout.pop();
    ctrl.defaultIdleWarn = $rootScope.$$listeners.IdleWarn.pop();
    ctrl.defaultIdleStart = $rootScope.$$listeners.IdleStart.pop();
    IdleHelper.setUpTimeout(ctrl.handleTimeoutSave);
  };
  ctrl.handleTimeoutSave = /*#__PURE__*/(0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4() {
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          if (ctrl.selectedNote && (ctrl.selectedNote.value || ctrl.selectedNote.attachments.length)) {
            ctrl.saveNote(ctrl.report, ctrl.selectedNote, true);
          }
          if (ctrl.referenceId) {
            ctrl.saveReferenceId(ctrl.referenceId, true);
          }
          if ((!ctrl.selectedNote || !ctrl.selectedNote.value) && !ctrl.referenceId) {
            Amplify.Auth.signOut();
          }
        case 3:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  ctrl.init();
  ctrl.setUpTimeout();
  $scope.$on('$destroy', function () {
    $rootScope.$$listeners.IdleTimeout = [ctrl.defaultIdleTimeout];
    $rootScope.$$listeners.IdleWarn = [ctrl.defaultIdleWarn];
    $rootScope.$$listeners.IdleStart = [ctrl.defaultIdleStart];
  });
  ctrl.showImage = function (url) {
    $uibModal.open({
      template: "<div style=\"display:flex; align-items: center; justify-content: center\"><img ng-src=\"{{ctrl.thumbnail}}\"></div>",
      // eslint-disable-next-line object-shorthand
      controller: function controller() {
        ctrl = this;
        ctrl.thumbnail = url.thumbnail;
      },
      controllerAs: 'ctrl'
    });
  };
};